import React, { FC } from 'react'
import { Box, Row } from '../../../../legacy-design-system/form'
import { BugtrackerConfig } from '../api/shared'
import { DefaultAssigneeField } from './default-assignee-field'
import { DefaultEpicField } from './default-epic-field'
import { DefaultIssueTypeField } from './default-issue-type-field'
import { ProjectNameField } from './project-name-field'

export const ProjectFields: FC<{ bugtracker?: BugtrackerConfig }> = ({
  bugtracker
}) => {
  return (
    <Row>
      <Box basis={3}>
        <ProjectNameField />
      </Box>
      <Box basis={3}>
        <DefaultEpicField bugtracker={bugtracker} />
      </Box>
      <Box basis={3}>
        <DefaultAssigneeField bugtracker={bugtracker} />
      </Box>
      <Box basis={3}>
        <DefaultIssueTypeField />
      </Box>
    </Row>
  )
}
